import CustomNode from "../Nodes/CustomNode";
import GroupNode from "../Nodes/GroupNode";

export const nodeTypes = {
  custom: CustomNode,
  group: GroupNode,
};
